// extracted by mini-css-extract-plugin
export default {"container":"MultiChoice_container__XXGrW","options":"MultiChoice_options__d-1YY"};